module.exports = __webpack_public_path__ + "static/media/clipboard.b500177f.png";